export enum ModuleType {
    MCA_CONFIG = 'MCA_CONFIG',
    REALM = 'REALM',
    MAIN_MENU = 'MAIN_MENU',
    POLICY_VIEWER = 'POLICY_VIEWER',
    CLAIM_SUBMISION = 'CLAIM_SUBMISION',
}
